import { Grid } from '@mui/material';
import { ReferenceImageList } from '../ReferenceImageList';
import { ReferenceImagePreview } from '../ReferenceImagePreview';

export interface ReferenceImageProps {
  readOnly: boolean | undefined;
  selectedImages: string[];
  onAddImage: (image: string) => void;
  onRemoveImage: (image: string) => void;

  disabled: boolean;
  onLock: (field: string, locked: boolean) => void;
  disabledLock: boolean;
  displayedLock: boolean;
  isLocked: boolean;
}

export const ReferenceImage = (props: ReferenceImageProps): JSX.Element => {
  return(
    <>
          <Grid container spacing={14}>
            <Grid size={8} sx={{ maxWidth: '650px', display:'flex', alignItems:'start', marginLeft:'-8px'}} >
              <ReferenceImageList
                readOnly={props.readOnly}
                selectedImages={props.selectedImages}
                disabled={props.disabled}
                onLock={props.onLock}
                disabledLock={props.disabledLock}
                displayedLock={props.displayedLock}
                isLocked={props.isLocked}
                labelId={'references'}
              />
            </Grid>
            <Grid size={4} sx={{ maxWidth: '250px' }} >
                <ReferenceImagePreview

                  readOnly={props.readOnly}
                  onAddImage={props.onAddImage}
                  onRemoveImage={props.onRemoveImage}
                  selectedImages={props.selectedImages}
                />
            </Grid>
          </Grid>
    </>
  );
};